/* eslint-disable react/display-name */
import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import Login from './screens/Admin/Login';
import AdminTab from './AdminTab';
import { User } from './utils/types/Users';
import { connect } from 'react-redux';
import { Icon, Image } from 'react-native-elements';
import FirebaseContext from './components/FirebaseContext';
import { RootState } from './redux';
import logo from '../assets/icon.png';
import { View, Text } from 'react-native';
import { appName } from './utils/constants';

export type RootStackParamList = {
	Login: undefined;
	Dashboard: undefined;
};

const Stack = createStackNavigator<RootStackParamList>();

interface AdminTabProps {
	user: User;
}

function AdminStack({ user }: AdminTabProps): JSX.Element {
	return (
		<Stack.Navigator>
			{user.role == null ? (
				<Stack.Screen
					name="Login"
					component={Login}
					options={{
						headerShown: false,
					}}
				/>
			) : (
				<Stack.Screen
					name="Dashboard"
					component={AdminTab}
					options={{
						headerTitle: () => {
							return (
								<View style={{ flexDirection: 'row', flex: 1 }}>
									<Image source={logo} style={{ width: 40, height: 40 }} />
									<Text
										style={{
											fontWeight: '700',
											fontSize: 16,
											lineHeight: 16,
											textAlignVertical: 'center',
											alignSelf: 'center',
											marginLeft: 4,
										}}
									>{`${appName} - Dashboard`}</Text>
								</View>
							);
						},
						headerRight: () => (
							<View style={{ flexDirection: 'row', right: 20 }}>
								<Icon
									name="user"
									type="feather"
									onPress={() => {
										// FirebaseContext.auth().signOut();
									}}
								/>
								<Text style={{ alignSelf: 'center', fontWeight: '700', fontSize: 16, lineHeight: 16, marginRight: 12 }}>
									Hi {user.firstName} &nbsp;
								</Text>
								<Icon
									name="log-out"
									type="feather"
									onPress={() => {
										FirebaseContext.auth().signOut();
									}}
								/>
							</View>
						),
					}}
				/>
			)}
		</Stack.Navigator>
	);
}

const mapStateToProps = (state: RootState) => {
	const { user } = state;
	return {
		user,
	};
};

export default connect(mapStateToProps)(AdminStack);
